import { Link } from "react-router-dom";
import loginLogo from "../../assets/logiscreen.png";

const ChangePassword = () => {
  return (
    <div className="h-screen w-screen overflow-hidden bg-white">
      {/* ✅ Desktop View */}
      <div className="hidden md:flex flex-row items-center justify-center h-screen p-8 bg-white">
        {/* Left: Logo */}
        <div className="md:w-1/2 w-full md:flex justify-center items-center">
          <img src={loginLogo} alt="Illustration" className="md:w-3/4" />
        </div>

        {/* Right: Form */}
        <div className="w-full md:w-1/2 max-w-md">
          <h2 className="text-xl font-bold mb-4 text-center">Change New Password</h2>
          <p className="text-gray-500 text-left text-xs mb-4">
            Enter a different password from the previous one
          </p>
          <form className="space-y-3">
            <input
              type="password"
              placeholder="New Password"
              autoComplete="new-password"
              className="w-full border p-2 rounded-md"
            />
            <input
              type="password"
              placeholder="Confirm Password"
              autoComplete="new-password"
              className="w-full border p-2 rounded-md"
            />
            <div className="flex justify-center items-center">
              <Link
                to="/SuccessPageNew"
                className="w-full bg-primary text-white py-2 px-2 text-center mt-4 rounded-md"
              >
                Submit
              </Link>
            </div>
          </form>
        </div>
      </div>

      {/* ✅ Mobile View */}
      <div className="md:hidden relative h-full w-full">
        {/* Background Image */}
        <div
          className="absolute inset-0 z-0 w-full h-full"
          style={{
            backgroundImage: `url(${loginLogo})`,
            backgroundSize: "contain",
            backgroundPosition: "top center",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* Black overlay with opacity */}
        <div className="absolute inset-0 bg-black opacity-70 z-0" />

        {/* Bottom Popup */}
        <div className="absolute bottom-0 left-0 right-0 z-20 bg-white rounded-t-3xl px-6 pt-4 pb-6 shadow-2xl max-h-[80%] overflow-y-auto">
          {/* Handle bar */}
          <div className="w-14 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

          {/* Title */}
          <h2 className="text-xl font-bold mb-4 text-center">Change New Password</h2>
          <p className="text-gray-500 text-left text-xs mb-4">
            Enter a different password from the previous one
          </p>

          {/* Form */}
          <form className="space-y-3">
            <input
              type="password"
              placeholder="New Password"
              autoComplete="new-password"
              className="w-full border p-2 rounded-md"
            />
            <input
              type="password"
              placeholder="Confirm Password"
              autoComplete="new-password"
              className="w-full border p-2 rounded-md"
            />
            <div className="flex justify-center items-center">
              <Link
                to="/SuccessPageNew"
                className="w-full bg-primary text-white py-2 px-2 text-center mt-4 rounded-md"
              >
                Submit
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
